// angular
//  .module("HeroPRO")
//  .controller("DeleteOfficeController", deleteOfficeController);


import _ from 'lodash';
import './deleteOffice.scss';


/* @ngInject */
export default function deleteOfficeController($uibModalInstance, selectedOffice, UserData, OfficesFactory, $rootScope) {
    const vm = this;
    vm.selectedOffice = selectedOffice;
    vm.selectedlocation = {};
    vm.contentShown = 'deleteInProgress';
    vm.processing = false;
    vm.locations = [];
    vm.successData = [];

    vm.defaultLocation = {
        ContractorId: -1,
        LocationNickname: 'Choose Office',
    };


    vm.closeModal = () => {
        let result = false;

        if (vm.contentShown === 'deleteSuccess') {
            result = true;
        }

        $uibModalInstance.close(result);
    };

    // Check if default Office dropdown value is selected
    function validateOfficeSelection() {
        if (!vm.selectedLocation || vm.selectedLocation.ContractorId === -1) {
            vm.selectLocationForm.$setValidity('office-not-selected', false);
        } else {
            vm.selectLocationForm.$setValidity('office-not-selected', true);
        }
    }

    vm.locationClicked = (location) => {
        vm.selectedLocation = location;
        validateOfficeSelection();
    };

    function deleteOffice(payload) {
        OfficesFactory.reassignUsersAndDeleteOffice(payload).then(() => {
            vm.processing = false;
            vm.contentShown = 'deleteSuccess';
            vm.successData.push([
                vm.selectedLocation.LocationNickname,
            ]);
            UserData.resetPromises().then(() => {
                $rootScope.$broadcast('officesUpdated');
            });
        });
    }

    vm.reassignEmployeesAndDeleteOffice = () => {
    // (ajt - 5/17/2016) Replace with general validation function if additional fields are added.
        validateOfficeSelection();
        if (vm.selectLocationForm.$valid) {
            vm.processing = true;
            const payload = {
                DeleteContractorLocationId: vm.selectedOffice.ContractorId,
                NewContractorLocationId: vm.selectedLocation.ContractorId,
            };
            deleteOffice(payload);
        } else {
            // console.log('Not valid');
        }
    };

    // Loads locations for dropdown
    function getLocations() {
        UserData.getKBYGLocations().then((response) => {
            vm.locations = response;
            if (_.findWhere(vm.locations, { ContractorId: -1 }) === undefined) {
                vm.locations.unshift(vm.defaultLocation);
            }
            // (ajt - 6/24/2016) Remove selected office from DropDown selection list.
            vm.locations = _.filter(vm.locations, location => location.ContractorId !== vm.selectedOffice.ContractorId);
            vm.selectedLocation = vm.locations[0];
        });
    }

    function init() {
        getLocations();
    }
    init();
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/deleteOffice/deleteOfficeController.js